/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum TypeNotification {
  Sms = 'Sms',
  Email = 'Email',
  Push = 'Push',
}
